module.exports = __webpack_public_path__ + "img/telegram.73f9a0ed.svg";